/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeviceStatusModel
 */
export interface DeviceStatusModel {
    /**
     * 
     * @type {string}
     * @memberof DeviceStatusModel
     */
    vividiVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceStatusModel
     */
    vbmVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceStatusModel
     */
    vbmVividiImageName?: string;
    /**
     * 
     * @type {number}
     * @memberof DeviceStatusModel
     */
    uptime?: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceStatusModel
     */
    fps?: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceStatusModel
     */
    cpuTemperature?: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceStatusModel
     */
    tpuTemperature?: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceStatusModel
     */
    ramTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceStatusModel
     */
    ramFree?: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceStatusModel
     */
    swapTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceStatusModel
     */
    swapFree?: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceStatusModel
     */
    spaceCapacity?: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceStatusModel
     */
    spaceAvailable?: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceStatusModel
     */
    cpuLoadavg1?: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceStatusModel
     */
    cpuLoadavg5?: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceStatusModel
     */
    cpuLoadavg15?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceStatusModel
     */
    undervoltageNow?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceStatusModel
     */
    undervoltageEver?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceStatusModel
     */
    armFreqCappedNow?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceStatusModel
     */
    armFreqCappedEver?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceStatusModel
     */
    throttledNow?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceStatusModel
     */
    throttledEver?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceStatusModel
     */
    softTempLimitNow?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceStatusModel
     */
    softTempLimitEver?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DeviceStatusModel
     */
    generation?: number;
    /**
     * 
     * @type {string}
     * @memberof DeviceStatusModel
     */
    imsi?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceStatusModel
     */
    iccid?: string;
    /**
     * 
     * @type {number}
     * @memberof DeviceStatusModel
     */
    socketUptime?: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceStatusModel
     */
    brightness?: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceStatusModel
     */
    cameraShiftProbability?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceStatusModel
     */
    isReferenceCaptureSet?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DeviceStatusModel
     */
    lastProcessedCaptureTimestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceStatusModel
     */
    lastDatabaseTimestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceStatusModel
     */
    lastRefocusTimestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceStatusModel
     */
    modelVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceStatusModel
     */
    vehicleModelVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceStatusModel
     */
    observedAt: string;
    /**
     * 
     * @type {number}
     * @memberof DeviceStatusModel
     */
    spaceTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceStatusModel
     */
    spaceFree?: number;
}

export function DeviceStatusModelFromJSON(json: any): DeviceStatusModel {
    return DeviceStatusModelFromJSONTyped(json, false);
}

export function DeviceStatusModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceStatusModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'vividiVersion': !exists(json, 'vividi_version') ? undefined : json['vividi_version'],
        'vbmVersion': !exists(json, 'vbm_version') ? undefined : json['vbm_version'],
        'vbmVividiImageName': !exists(json, 'vbm_vividi_image_name') ? undefined : json['vbm_vividi_image_name'],
        'uptime': !exists(json, 'uptime') ? undefined : json['uptime'],
        'fps': !exists(json, 'fps') ? undefined : json['fps'],
        'cpuTemperature': !exists(json, 'cpu_temperature') ? undefined : json['cpu_temperature'],
        'tpuTemperature': !exists(json, 'tpu_temperature') ? undefined : json['tpu_temperature'],
        'ramTotal': !exists(json, 'ram_total') ? undefined : json['ram_total'],
        'ramFree': !exists(json, 'ram_free') ? undefined : json['ram_free'],
        'swapTotal': !exists(json, 'swap_total') ? undefined : json['swap_total'],
        'swapFree': !exists(json, 'swap_free') ? undefined : json['swap_free'],
        'spaceCapacity': !exists(json, 'space_capacity') ? undefined : json['space_capacity'],
        'spaceAvailable': !exists(json, 'space_available') ? undefined : json['space_available'],
        'cpuLoadavg1': !exists(json, 'cpu_loadavg_1') ? undefined : json['cpu_loadavg_1'],
        'cpuLoadavg5': !exists(json, 'cpu_loadavg_5') ? undefined : json['cpu_loadavg_5'],
        'cpuLoadavg15': !exists(json, 'cpu_loadavg_15') ? undefined : json['cpu_loadavg_15'],
        'undervoltageNow': !exists(json, 'undervoltage_now') ? undefined : json['undervoltage_now'],
        'undervoltageEver': !exists(json, 'undervoltage_ever') ? undefined : json['undervoltage_ever'],
        'armFreqCappedNow': !exists(json, 'arm_freq_capped_now') ? undefined : json['arm_freq_capped_now'],
        'armFreqCappedEver': !exists(json, 'arm_freq_capped_ever') ? undefined : json['arm_freq_capped_ever'],
        'throttledNow': !exists(json, 'throttled_now') ? undefined : json['throttled_now'],
        'throttledEver': !exists(json, 'throttled_ever') ? undefined : json['throttled_ever'],
        'softTempLimitNow': !exists(json, 'soft_temp_limit_now') ? undefined : json['soft_temp_limit_now'],
        'softTempLimitEver': !exists(json, 'soft_temp_limit_ever') ? undefined : json['soft_temp_limit_ever'],
        'generation': !exists(json, 'generation') ? undefined : json['generation'],
        'imsi': !exists(json, 'imsi') ? undefined : json['imsi'],
        'iccid': !exists(json, 'iccid') ? undefined : json['iccid'],
        'socketUptime': !exists(json, 'socket_uptime') ? undefined : json['socket_uptime'],
        'brightness': !exists(json, 'brightness') ? undefined : json['brightness'],
        'cameraShiftProbability': !exists(json, 'camera_shift_probability') ? undefined : json['camera_shift_probability'],
        'isReferenceCaptureSet': !exists(json, 'is_reference_capture_set') ? undefined : json['is_reference_capture_set'],
        'lastProcessedCaptureTimestamp': !exists(json, 'last_processed_capture_timestamp') ? undefined : json['last_processed_capture_timestamp'],
        'lastDatabaseTimestamp': !exists(json, 'last_database_timestamp') ? undefined : json['last_database_timestamp'],
        'lastRefocusTimestamp': !exists(json, 'last_refocus_timestamp') ? undefined : json['last_refocus_timestamp'],
        'modelVersion': !exists(json, 'model_version') ? undefined : json['model_version'],
        'vehicleModelVersion': !exists(json, 'vehicle_model_version') ? undefined : json['vehicle_model_version'],
        'observedAt': json['observed_at'],
        'spaceTotal': !exists(json, 'space_total') ? undefined : json['space_total'],
        'spaceFree': !exists(json, 'space_free') ? undefined : json['space_free'],
    };
}

export function DeviceStatusModelToJSON(value?: DeviceStatusModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'vividi_version': value.vividiVersion,
        'vbm_version': value.vbmVersion,
        'vbm_vividi_image_name': value.vbmVividiImageName,
        'uptime': value.uptime,
        'fps': value.fps,
        'cpu_temperature': value.cpuTemperature,
        'tpu_temperature': value.tpuTemperature,
        'ram_total': value.ramTotal,
        'ram_free': value.ramFree,
        'swap_total': value.swapTotal,
        'swap_free': value.swapFree,
        'space_capacity': value.spaceCapacity,
        'space_available': value.spaceAvailable,
        'cpu_loadavg_1': value.cpuLoadavg1,
        'cpu_loadavg_5': value.cpuLoadavg5,
        'cpu_loadavg_15': value.cpuLoadavg15,
        'undervoltage_now': value.undervoltageNow,
        'undervoltage_ever': value.undervoltageEver,
        'arm_freq_capped_now': value.armFreqCappedNow,
        'arm_freq_capped_ever': value.armFreqCappedEver,
        'throttled_now': value.throttledNow,
        'throttled_ever': value.throttledEver,
        'soft_temp_limit_now': value.softTempLimitNow,
        'soft_temp_limit_ever': value.softTempLimitEver,
        'generation': value.generation,
        'imsi': value.imsi,
        'iccid': value.iccid,
        'socket_uptime': value.socketUptime,
        'brightness': value.brightness,
        'camera_shift_probability': value.cameraShiftProbability,
        'is_reference_capture_set': value.isReferenceCaptureSet,
        'last_processed_capture_timestamp': value.lastProcessedCaptureTimestamp,
        'last_database_timestamp': value.lastDatabaseTimestamp,
        'last_refocus_timestamp': value.lastRefocusTimestamp,
        'model_version': value.modelVersion,
        'vehicle_model_version': value.vehicleModelVersion,
        'observed_at': value.observedAt,
        'space_total': value.spaceTotal,
        'space_free': value.spaceFree,
    };
}

